import { usePageMeta } from "@/components/pepmuse/usePageMeta";
import { Hero } from "@/components/pepmuse/Hero";
import { Marquee } from "@/components/pepmuse/Marquee";
import { Services } from "@/components/pepmuse/Services";
import { Included } from "@/components/pepmuse/Included";
import { Process } from "@/components/pepmuse/Process";
import { Faq } from "@/components/pepmuse/Faq";
import { ClosingCTA } from "@/components/pepmuse/ClosingCTA";

export default function Home({ onBuild }) {
  usePageMeta();
  return (
    <>
      <Hero onBuild={onBuild} />
      <Marquee />
      <Services />
      <Included />
      <Process />
      <Faq />
      <ClosingCTA onBuild={onBuild} />
    </>
  );
}
